import { Component, OnInit} from '@angular/core';
import * as $ from 'jquery';
import { trigger, style, animate, transition, state } from '@angular/animations';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit
{
 showYourTurnImg = false;

  ngOnInit()
  {
      setInterval(() => {
      this.showYourTurnImg = !this.showYourTurnImg;
    }, 2000);
  }

}
